export const PRODUCTLIST_FETCH_START = 'PRODUCTLIST_FETCH_START';
export const PRODUCTLIST_FETCH_SUCCESS = 'PRODUCTLIST_FETCH_SUCCESS';
export const PRODUCTLIST_FETCH_ERROR = 'PRODUCTLIST_FETCH_ERROR';

export const PRODUCT_FETCH_START = 'PRODUCT_FETCH_START';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_FAIL = 'PRODUCT_FETCH_FAIL';

export const PRODUCTREVIEW_FETCH_START = 'PRODUCTREVIEW_FETCH_START';
export const PRODUCTREVIEW_FETCH_SUCCESS = 'PRODUCTREVIEW_FETCH_SUCCESS';
export const PRODUCTREVIEW_FETCH_FAIL = 'PRODUCTREVIEW_FETCH_FAIL';

export const CREATE_REVIEW_START = 'CREATE_REVIEW_START';
export const CREATE_REVIEW_SUCCESS = 'CREATE_REVIEW_SUCCESS';
export const CREATE_REVIEW_FAIL = 'CREATE_REVIEW_FAIL';
export const CREATE_REVIEW_RESET = 'CREATE_REVIEW_RESET';

export const DELETE_PRODUCT_START = 'DELETE_PRODUCT_START';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAIL = 'DELETE_PRODUCT_FAIL';
export const DELETE_PRODUCT_RESET = 'DELETE_PRODUCT_RESET';

export const CREATE_PRODUCT_START = 'CREATE_PRODUCT_START';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAIL = 'CREATE_PRODUCT_FAIL';
export const CREATE_PRODUCT_RESET = 'CREATE_PRODUCT_RESET';

export const EDIT_PRODUCT_START = 'EDIT_PRODUCT_START';
export const EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
export const EDIT_PRODUCT_FAIL = 'EDIT_PRODUCT_FAIL';
export const EDIT_PRODUCT_RESET = 'EDIT_PRODUCT_RESET';
